import { Link } from 'react-router-dom';

/**
 * Plaid connection page — scaffolded for the inevitable wiring.
 * Real connect button will use a Cloud Function that mints a Link token; this
 * page already lays out the contract so the wiring later is a drop-in.
 */
export function PlaidIntegration() {
  return (
    <div className="mx-auto w-full max-w-4xl space-y-6 px-6 py-6">
      <header>
        <div className="text-[10px] uppercase tracking-wider text-stone-400">Integration</div>
        <h1 className="text-2xl font-semibold text-stone-800">Plaid</h1>
        <p className="mt-1 text-sm text-stone-500">
          Link bank, credit card, brokerage, mortgage, and loan accounts. Nightly sync writes new
          statements into Bills and Documents automatically.
        </p>
      </header>

      <div className="rounded-2xl border border-stone-200 bg-white p-5 shadow-sm">
        <div className="text-[10px] uppercase tracking-wider text-amber-700">Setup required</div>
        <h2 className="mt-1 text-sm font-semibold text-stone-800">
          Plaid app credentials not yet in Secret Manager
        </h2>
        <p className="mt-2 text-xs leading-relaxed text-stone-600">
          To turn this on, sign up at <a href="https://dashboard.plaid.com" target="_blank" rel="noreferrer" className="text-[#BF5700] hover:underline">dashboard.plaid.com</a>,
          grab the <strong>PLAID_CLIENT_ID</strong> and <strong>PLAID_SECRET</strong> from the team
          settings, and drop them into Secret Manager:
        </p>
        <pre className="mt-3 overflow-x-auto rounded bg-stone-100 px-3 py-2 text-[11px] text-stone-800">
{`npx firebase-tools functions:secrets:set PLAID_CLIENT_ID
npx firebase-tools functions:secrets:set PLAID_SECRET
npx firebase-tools deploy --only functions`}
        </pre>
        <p className="mt-3 text-xs text-stone-600">
          After that, this page will replace itself with a Connect button that pops the Plaid Link
          flow and stores the resulting access tokens encrypted at <code>integrations/{'{uid}'}/plaid</code>.
        </p>
        <p className="mt-3 text-xs text-stone-500">
          The schema is already in place — see <code>shared/src/schemas/account.ts</code> for the
          shape the nightly sync writes.
        </p>
      </div>

      <div className="rounded-2xl border border-stone-200 bg-white p-5 shadow-sm">
        <h2 className="text-sm font-semibold text-stone-800">Cost back-of-envelope</h2>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-xs text-stone-600">
          <li>Plaid dev tier is free.</li>
          <li>Production: ~$0.30 / linked account / month. For a family of 5 with 20 accounts that's ~$6/mo.</li>
          <li>Liabilities + Investments add-ons are extra, ~$0.20/account/month each.</li>
        </ul>
        <Link to="/settings" className="mt-4 inline-block text-xs text-[#BF5700] hover:underline">
          ← Back to settings
        </Link>
      </div>
    </div>
  );
}
